import { graphql } from "~/gql";

export const COPY_MATTER_PHASES = graphql(/* GraphQL */ `
  mutation copyMatterPhases($targetMatterId: Float!, $copiedMatterId: Float!) {
    copyMatterPhases(targetMatterId: $targetMatterId, copiedMatterId: $copiedMatterId) {
      phases {
        ...PhaseParts
      }
      assumptions {
        ...AssumptionFragment
      }
      exclusions {
        ...ExclusionFragment
      }
      disbursements {
        ...DisbursementParts
      }
    }
  }
`);
